import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PatientProvider } from "@/context/PatientContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import TosModal from "@/components/TosModal";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import Doctors from "@/pages/Doctors";
import Appointments from "@/pages/Appointments";
import Medications from "@/pages/Medications";
import Pharmacies from "@/pages/Pharmacies";
import Addresses from "@/pages/Addresses";
import Insurance from "@/pages/Insurance";
import Reminders from "@/pages/Reminders";
import Todos from "@/pages/Todos";
import PillScanner from "@/pages/PillScanner";
import Profile from "@/pages/Profile";
import Timeline from "@/pages/Timeline";
import CareSummary from "@/pages/CareSummary";
import AcceptInvite from "@/pages/AcceptInvite";

function App() {
  return (
    <AuthProvider>
      <PatientProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accept/:code" element={<AcceptInvite />} />
            <Route path="/app" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/app/patients" element={<ProtectedRoute><Layout><Patients /></Layout></ProtectedRoute>} />
            <Route path="/app/doctors" element={<ProtectedRoute><Layout><Doctors /></Layout></ProtectedRoute>} />
            <Route path="/app/appointments" element={<ProtectedRoute><Layout><Appointments /></Layout></ProtectedRoute>} />
            <Route path="/app/medications" element={<ProtectedRoute><Layout><Medications /></Layout></ProtectedRoute>} />
            <Route path="/app/pharmacies" element={<ProtectedRoute><Layout><Pharmacies /></Layout></ProtectedRoute>} />
            <Route path="/app/addresses" element={<ProtectedRoute><Layout><Addresses /></Layout></ProtectedRoute>} />
            <Route path="/app/insurance" element={<ProtectedRoute><Layout><Insurance /></Layout></ProtectedRoute>} />
            <Route path="/app/reminders" element={<ProtectedRoute><Layout><Reminders /></Layout></ProtectedRoute>} />
            <Route path="/app/todos" element={<ProtectedRoute><Layout><Todos /></Layout></ProtectedRoute>} />
            <Route path="/app/pill-scanner" element={<ProtectedRoute><Layout><PillScanner /></Layout></ProtectedRoute>} />
            <Route path="/app/timeline" element={<ProtectedRoute><Layout><Timeline /></Layout></ProtectedRoute>} />
            <Route path="/app/patients/:patientId/summary" element={<ProtectedRoute><CareSummary /></ProtectedRoute>} />
            <Route path="/app/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <TosModal />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </PatientProvider>
    </AuthProvider>
  );
}

export default App;
